 <template>
  <div class="container">
    <div class="status-bar" v-if="state === COUNTDOWN || state === PROGRESSING">
      <div>単語編</div>
      {{secondToMinutes(timeRemaining)}}
      <AnimatedNumber :value="totalScore" />
      {{2 - mistakeCount}}
    </div>
    <transition name="window-slide-fade">
      <div class="training-window" :class="{'just-selected': justSelected }" v-if="activeTraining">
        <CountDown v-if="state === COUNTDOWN" @finished-count-down="doAfterCountdownFinished" />

        <Finished v-if="state === FINISHED" @show-result="showResult" />

        <div v-if="state === PROGRESSING" style="height: 100%">
          <div class="window-inner">
            <div>
              <div class="window-left">問題の{{hasSpace('tet dis') ? '文章' : '単語'}}</div>
              <div class="window-right">{{current.problem.word}}</div>
            </div>
            <div style>
              <div class="window-left">モデル発音記号</div>

              <div class="window-right">
                <div
                  v-if="interimVisible || !result"
                  style="diplay: flex; flex-direction: row; flex-wrap: wrap; align-item: center"
                >
                  <div v-for="(word, index) in currentModelProns" :key="index" class="model-pron">
                    <div v-for="ph in word">{{ph.withStress}}</div>
                  </div>
                </div>

                <div v-if="!interimVisible && result" class="final speech-text">
                  <span
                    v-for="(r, index) in result.modelOutput"
                    :key="index"
                    style="display:inline-block; min-width: .5rem;position: relative"
                    :style="r.isRemoved ? 'color:#f88' : ''"
                    class="phoneme"
                  >{{r.isSpace ? ' ' : r.phoneme}}</span>
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div class="window-left">意味 / 発音難度</div>

              <div class="window-right" style="font-size: 1.2rem">{{current.problem.ja}} ★★★★★</div>
            </div>

            <div style="flex: 1.5">
              <div class="window-left">ユーザー発音</div>
              <div class="window-right">
                <div class="state-indicator">
                  <Listening class="spinner" :color="indicatorState ? '#ddd' : '#f88'" />
                  <div
                    class="text"
                    :class="[{'listening': !indicatorState}, {'waiting': indicatorState}]"
                  >{{ interimVisible ? '音声入力中' : '待機中'}}</div>
                </div>
                <div
                  style="width: 100%; height: 100%; display:flex; flex-direction: column; justify-content: space-evenly; align-items:center;"
                >
                  <div v-show="interimVisible" class="interim speech-text">{{interimTranscription}}</div>
                  <!-- <transition name="zoom-fade"> -->
                  <div v-show="!interimVisible" class="final speech-text">{{finalTranscription}}</div>
                  <!-- </transition> -->
                  <ScoreGauge
                    ref="gauge"
                    :currentScore="finalScore"
                    class="gauge"
                    :class="[{'hide': interimVisible},{'show': !interimVisible}]"
                  />
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div class="window-left">ユーザー発音記号</div>

              <div class="window-right">
                <transition name="fade">
                  <span v-if="!interimVisible && result" class="final speech-text">
                    <span
                      v-for="(r, index) in result.userOutput"
                      :key="index"
                      style="display:inline-block; min-width: .3rem;"
                      :style="r.isAdded ? 'color:rgba(0, 50, 40, 0.6)' : ''"
                    >{{r.isSpace ? ' ' : r.phoneme}}</span>
                  </span>
                </transition>
              </div>
            </div>
            <!-- <transition name="fade">
          <div class="user" v-if="!interimVisible">{{result.detail.textOriginal}}</div>
        </transition>
            <div class="interim" v-if="interimVisible">{{interimTranscription}}</div>-->
          </div>
        </div>
      </div>
    </transition>

    <span
      class="close-modal"
      :style="modalColor"
      v-if="state === PROGRESSING || state === COUNTDOWN || state === FINISHED"
    ></span>

    <div v-show="state === BEFORE">
      <h1>PronAid Pronunciatin Proficiency Test (PPPT)</h1>

      <div v-if="admin">
        <el-input v-model="timeRemaining"></el-input>
      </div>
      <div class="before-container">
        <h2>テストをはじめるまえに</h2>

        <ol style="min-width: 600px; text-align:left; display: inline-block">
          <li>Chromeブラウザには、必ずマイクの使用を許可してください。</li>
          <li>トライアル版では、苦手な発音の表示といった一部の機能が制限されます。</li>
          <li>テストは5分間です、途中で終了するとスコアの計算ができませんのでご注意ください。</li>
          <li>全ての発話データテキストは、今後サービスの質向上を図るため、また研究目的のために利用させていただきます。なお、音声データは収集しておりません。</li>
          <li>マイクが受け取る音量が大きすぎたり、小さすぎたりすると、音声認識がうまく動作しません。話さないときは出来るだけ静かな環境で、話しているときはできるだけはっきりと話すようにしてください。</li>
        </ol>

        <!-- <h3>Duration</h3>

        <div>
          <input type="range" id="start" name="volume" min="10" max="600" v-model="timeRemaining" />
          {{timeRemaining}}
          <label for="volume">Duration</label>
        </div>-->

        <button class="button" @click="showTraining">利用規約に同意してテストを開始</button>
      </div>
    </div>

    <div v-show="state === RESULT">
      <h1>発音テスト結果</h1>

      <div class="header">
        <img class="icon" src="@/assets/analytics.svg" />
        <h2 class="text">テスト結果サマリー</h2>
        <div class="header-description">音声認識の結果と、「ネイティブの口」による独自基準によってスコアリングされた採点結果です。</div>
      </div>

      <div class="total-score">
        <AnimatedNumber :value="totalScore" />
      </div>

      <div class="score-bar-container">
        <div class="score-bar" :style="scoreBarStyle"></div>
      </div>

      <div class="error-container" style="margin: 50px 0">
        <chartist
          class="phoneme-pie"
          ratio="ct-chart"
          type="Pie"
          :data="chartData"
          :options="chartOptions"
        ></chartist>
        <table border="0">
          <tr>
            <th style="max-width: 40px">順番</th>
            <th>発音記号</th>
            <th>頻度</th>
          </tr>

          <tr
            v-for="(data, index) in errorArray "
            :key="index"
            v-show="showAllErrors ? index < 13 : true"
          >
            <td>{{index+1}}</td>
            <td>{{data.phoneme}}</td>
            <td>{{data.freq}}</td>
          </tr>
          <tr class="toggle">
            <td
              colspan="3"
              @click="showAllErrors = !showAllErrors"
            >{{ !showAllErrors ? `隠す`: `全ての結果を表示する`}}</td>
          </tr>
        </table>
      </div>

      <div class="header">
        <img class="icon" src="@/assets/volume-max-pink.svg" />
        <h2 class="text">録音データ</h2>
        <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
      </div>

      <table border="0">
        <tr>
          <th>順番</th>
          <th>問題の語・熟語・文章</th>
          <th>音声認識の結果</th>
          <th>スコア</th>
          <th>正否</th>
        </tr>

        <tr
          v-for="(data, index) in resultData"
          :key="index"
          v-show="showAllResultData ? index < 10 : true"
        >
          <td>{{index+1}}</td>
          <td class="playable">
            <span @click="playProblemText(data.problemText)">{{data.problemText}}</span>
          </td>
          <td class="playable">
            <span @click="playUserText(data.audio)">{{data.userText}}</span>
          </td>
          <td>{{data.score}}</td>
          <td>
            <img v-show="data.score >= 80" src="@/assets/correct.svg" width="20" />
          </td>
        </tr>
        <tr class="toggle">
          <td
            colspan="5"
            @click="showAllResultData = !showAllResultData"
          >{{ !showAllResultData ? `隠す`: `全ての結果を表示する`}}</td>
        </tr>
      </table>
      <div style="text-align: center">
        <button
          class="button"
          style="margin-top: 15px;vertical-align:middle; padding: 8px 16px; font-size: .92rem;"
          @click="saveAudiosWithZipped"
        >
          <img
            src="@/assets/download.svg"
            style="vertical-align:middle; margin-top: -2px; margin-right: 3px;"
            width="20px"
          />
          テストの録音済み音声データを全て保存する
        </button>
      </div>

      <div class="header">
        <img class="icon" src="@/assets/blackboard.svg" />
        <h2 class="text">おすすめレッスン</h2>
        <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
      </div>

      <div class="suggested-lesson">
        <LessonBlock
          v-for="(lesson, index) in suggestedLessons"
          :key="index"
          :lesson="lesson"
          class="lesson-block"
        />
      </div>

      <div class="lesson-item-header">
        <button class="button white" @click="goToDashboard">ダッシュボードに戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

import { Loading } from "element-ui";

import pronDict from "@/utils/PronDictionary";
import SpeechRecognizer from "@/utils/SpeechRecognizer";
import SpeechSynthesizer from "@/utils/SpeechSynthesizer";

import { CLEAR_SCORE, LANG, iconType } from "@/constants";
import { sleep } from "@/utils/functions";

import resultRepo from "@/utils/TestResultRepository";

import Vue from "vue";

import firebase from "firebase/app";
import "firebase/firestore";

const lessons = require("@/resources/lessons.json");

Vue.use(require("vue-chartist"));

const accurateInterval = require("accurate-interval");

const COUNTDOWN = "COUNTDOWN";
const PAUSED = "PAUSED";
const FINISHED = "FINISHED";
const RESULT = "RESULT";
const PROGRESSING = "PROGRESSING";
const BEFORE = "BEFORE";

// to be deleted

import { speechRecorder } from "@/utils/SpeechRecorder";
import { secondToMinutes } from "@/utils/functions";
import JSZip from "jszip";

const correctSE = new Audio(require("@/assets/correct.mp3"));
const incorrectSE = new Audio(require("@/assets/incorrect.mp3"));

const workbooks = require("@/resources/workbooks.json");

export default {
  name: "Test",
  components: {
    PerfectScrollbar,
    Score: require("../Lesson/Score").default,
    ScoreGauge: require("./ScoreGauge").default,
    Listening: require("@/components/Listening").default,
    CountDown: require("./CountDown").default,
    Finished: require("./Finished").default,
    AnimatedNumber: require("./AnimatedNumber").default,
    LessonBlock: require("../Dashboard/LessonBlock").default
  },
  computed: {
    indicatorState() {
      return this.interimVisible;
    }
  },
  data() {
    return {
      admin: false,
      suggestedLessons: [],
      errorDistribution: {},
      errorArray: [{ phoneme: "", freq: 0 }],
      showAllErrors: false,
      chartData: {
        labels: [],
        series: []
      },
      chartOptions: {
        width: "500px",
        height: "500px"
      },
      //STATES
      BEFORE: BEFORE,
      COUNTDOWN: COUNTDOWN,
      PROGRESSING: PROGRESSING,
      RESULT: RESULT,
      PAUSED: PAUSED,
      FINISHED: FINISHED,
      // state: BEFORE,
      state: BEFORE,
      current: {
        index: 0,
        problem: {
          word: "",
          ja: "",
          difficulty: 0
        }
      },
      timeRemaining: 60 * 5,
      initialTimeRemaining: 0,
      mistakeCount: 0,
      currentModelProns: [],
      transition_name: "",
      totalProblemLength: 0,
      activeTraining: false,
      activeIndex: 0,
      showOriginalPron: true,
      sr: null,
      result: {
        modelOutput: null,
        userOutput: null
      },
      finalScore: 0,
      interimTranscription: "",
      finalTranscription: "",
      interimVisible: true,
      currentModelProns: null,
      justSelected: true,
      problems: [],
      modalColor: `background-color: rgba(0, 0, 0, 0.85);`,
      resultData: [],
      showAllResultData: false,
      totalScore: 0,
      scoreBarStyle: ``,
      isRecognizing: false
    };
  },
  beforeDestroy() {
    if (this.isRecognizing) {
      this.sr.stopRecog();
    }
  },
  beforeCreate() {
    // document.body.className = "lesson-body";
  },
  mounted() {
    document.body.addEventListener("keypress", e => {
      console.log(e.key);
      if (e.key === "t") {
        this.admin = !this.admin;
      }
    });
    let self = this;
    this.initialTimeRemaining = this.timeRemaining;
    self.scoreBarStyle = `width: 56%`;

    self.problems = Array.prototype.concat
      .apply(
        [],
        workbooks.map(wb => {
          return wb.problems;
        })
      )
      .sort((p, n) => {
        return p.difficulty - n.difficulty;
      });

    self.sr = new SpeechRecognizer({
      component: this,
      lang: LANG.EN,
      record: false,
      compare: false
    });
    document.addEventListener("speech-result", this.addResult);

    // speechRecorder.setMode("multiple");
    document.title = `PronAid | PronAid Pronunciatin Proficiency Test (PPPT)`;
  },
  methods: {
    goToDashboard() {
      this.$router.replace("/");
    },
    playProblemText(text) {
      SpeechSynthesizer.speak({
        text: text,
        rate: 0.8
      });
    },
    playUserText(audioBlob) {
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audio.play();
    },
    saveAudiosWithZipped() {
      const today = new Date();
      const date = `${today.getFullYear()}${today.getMonth() +
        1}${today.getDate()}-${today.getHours()}${today.getMinutes()}`;
      const zip = new JSZip();
      zip.file("[Score][Problem Text][Your Pronunciation]", "Hello World\n");
      this.resultData.forEach((data, index) => {
        zip.file(
          `[${data.score}][${data.problemText || "Not Found"}][${
            data.userText
          }].wav`,
          data.audio
        );
      });
      zip
        .generateAsync({ type: "blob" })
        .then(blob => saveAs(blob, `PronAid_Test_${date}`));
    },
    showResult() {
      let self = this;
      this.state = RESULT;
      this.closeModal();
      resultRepo.addResult({
        score: self.totalScore,
        createdAt: new Date()
      });

      // create chart

      const errorDistribution = this.errorDistribution;

      const distArray = Object.keys(errorDistribution).map(ph => {
        return {
          phoneme: ph,
          freq: errorDistribution[ph]
        };
      });

      const sortedArray = distArray.sort((a, b) => {
        if (a.freq > b.freq) return -1;
        if (a.freq < b.freq) return 1;
        return 0;
      });

      // suggest lessons

      let edittedArray = [];
      let pickedLessons = [];
      const maxPhonemes = 9;
      const pickNumber = 6;

      for (let i = 0; i < sortedArray.length; i++) {
        if (i < pickNumber) {
          pickedLessons.push(sortedArray[i].phoneme);
        }
        if (i < maxPhonemes) {
          edittedArray.push(sortedArray[i]);
        } else if (i === maxPhonemes) {
          edittedArray.push({
            freq: sortedArray[i].freq,
            phoneme: "other"
          });
        } else {
          edittedArray[maxPhonemes].freq += sortedArray[i].freq;
        }
      }

      let suggestedLessons = [];

      pickedLessons.forEach(ph => {
        suggestedLessons.push(
          lessons.filter(lesson => {
            return lesson.targetPhoneme === ph;
          })[0]
        );
      });
      console.log(suggestedLessons);
      this.suggestedLessons = suggestedLessons;
      this.errorArray = sortedArray;
      this.chartData = {
        labels: edittedArray.map(el => el.phoneme),
        series: edittedArray.map(el => el.freq)
      };

      const sendData = {
        uid: self.$store.state.auth.user.uid,
        name: self.$store.state.auth.user.name,
        date: new Date(),
        totalScore: self.totalScore,
        initialTimeRemaining: self.initialTimeRemaining,
        results: self.resultData.map(result => {
          return {
            problemText: result.problemText,
            userText: result.userText,
            score: result.score
          };
        })
      };

      firebase
        .firestore()
        .collection("TestResults")
        .add(sendData);
    },
    secondToMinutes(seconds) {
      return secondToMinutes(seconds);
    },
    doAfterCountdownFinished() {
      let self = this;
      this.state = PROGRESSING;
      this.flipSlide();
      setTimeout(() => {
        self.startTest();
        const timer = accurateInterval(
          () => {
            self.timeRemaining--;
            if (self.timeRemaining < 0) {
              self.endTest();
              self.state = FINISHED;
              timer.clear();
              self.modalColor = `background-color: rgba(250, 250, 250, 1)`;
            }
          },
          1000,
          { aligned: false, immediate: false }
        );
      }, 1000);
    },
    flipSlide() {
      // if (this.isRecognizing) {
      //   this.sr.stopRecog();
      // }
      // this.isRecognizing = false;
      let self = this;
      this.activeTraining = false;
      setTimeout(() => {
        if (self.state !== RESULT) {
          self.setNewProblem();
          // self.result.finalScore = 0;
          self.activeTraining = true;
          // self.sr.startRecog();
          // self.isRecognizing = true;
        }
      }, 1000);
    },

    speak() {
      SpeechSynthesizer.speak({
        text: this.current.problem.word,
        rate: this.rate,
        sr: this.sr
      });
    },

    hasSpace(str) {
      return str.indexOf(" ") >= 0;
    },

    findNewIndex() {
      const currentIndex = this.current.index;
      const problemsLength = this.problems.length;
      const index = Math.floor(Math.random() * problemsLength);
      return index;
    },

    setNewProblem() {
      let self = this;
      this.current.index = this.findNewIndex();
      this.interimVisible = true;
      this.current.problem = this.problems[this.current.index];
      pronDict.getIpaFromSingleText(this.current.problem.word).then(result => {
        self.currentModelProns = result;
      });
    },
    addResult(result) {
      const self = this;
      if (result.detail.isFinal) {
        const text = result.detail.textOriginal;
        const confidence = result.detail.confidence;
        const audioBlob = result.detail.audio;

        self.finalTranscription = result.detail.textOriginal;
        self.interimVisible = false;
        self.interimTranscription = "";

        pronDict
          .compareSymbolFromTexts(self.current.problem.word, text)
          .then(result => {
            self.result = result;
            const finalScore =
              Math.ceil(confidence * 100 * 0.2 + result.score * 0.8) || 0;
            self.totalScore += finalScore;
            self.finalScore = finalScore; // TODO don't insert this into result but root data()

            self.resultData.push({
              audio: audioBlob,
              score: finalScore,
              problemText: self.current.problem.word,
              userText: text
            });
            const modelOutput = result.modelOutput;
            modelOutput.forEach(ph => {
              if (ph.isRemoved && ph.phonemeWithoutStress) {
                if (self.errorDistribution[ph.phonemeWithoutStress]) {
                  self.$set(
                    self.errorDistribution,
                    ph.phonemeWithoutStress,
                    self.errorDistribution[ph.phonemeWithoutStress] + 1
                  );
                } else {
                  self.$set(self.errorDistribution, ph.phonemeWithoutStress, 1);
                }
              }
            });

            if (true) {
              // if (finalScore >= 80 || self.mistakeCount > 1) {
              setTimeout(() => {
                if (self.state !== RESULT) {
                  self.flipSlide();
                  self.mistakeCount = 0;
                }
              }, 1000);
            } else {
              self.mistakeCount++;
            }
          });
      } else {
        self.interimVisible = true;
        self.interimTranscription = result.detail.textOriginal;
      }
    },

    startTest() {
      this.sr.startRecog();
      this.isRecognizing = true;
    },

    showTraining(event) {
      this.state = COUNTDOWN;
      this.justSelected = true;
      const initialIndex = Math.floor(Math.random() * 100);
      this.current.problem = this.problems[initialIndex];
      const self = this;

      setTimeout(() => {
        this.justSelected = false;
      }, 0);

      this.activeTraining = true;

      this.setNewProblem();
    },
    endTest() {
      let self = this;
      this.sr.stopRecog();
      this.isRecognizing = false;
      document.removeEventListener("speech-result", self.addResult);
      this.resetUserInputRelated();
    },
    closeModal() {
      this.justSelected = true;
      this.activeTraining = false;
    },
    resetUserInputRelated() {
      this.$set(this, "result", null);
      this.interimTranscription = "";
    }
  }
};
</script>


<style lang="scss" scoped>
.lesson-block {
  display: inline-block;
}
.suggested-lesson {
  width: 100%;
  display: flex;
  flex-direction: row;

  justify-content: space-evenly;
  flex-wrap: wrap;
}
.error-container {
  display: flex;
  flex-direction: row;
  margin: 30px;
  .phoneme-pie {
    margin: 0 30px;
  }
}

.score-bar-container {
  width: 60%;
  margin: 20px auto 30px auto;
  height: 25px;
  border: 3px solid #333;
  .score-bar {
    width: 0%;
    height: 100%;
    background-color: #f88;
    transition: all 1s ease;
  }
}
.total-score {
  font-size: 3rem;
  text-align: center;
  font-weight: 800;
}

.icon,
.text {
  vertical-align: middle;
  display: inline-block;
}
.icon {
  width: 50px;
  margin-right: 10px;
  transition: 0.3s ease;
}

.before-container {
  text-align: center;
  width: 80%;
  margin: 0 auto;
}

.container {
  min-height: 100%;
  box-sizing: border-box;
  /* min-height: 100% !important; */
  padding: 100px 0;
  @include mq(sm) {
  }
  @include mq(md) {
  }

  @include mq(lg) {
  }
  position: relative;
  .back {
    border-radius: 50%;
    cursor: pointer;
    position: fixed;
    height: 25px;
    width: 25px;
    padding: 10px;
    color: white;
    background-color: #555;
    border: none;
    transform: translateX(-55px);
    font-size: 1.4rem;
    /* left: 100px; */
    top: 30px;
    &:hover {
      background-color: #666;
    }
  }
}

.training-window {
  width: 620px;
  height: 450px;
  font-size: 1.2rem;

  @include mq(sm) {
    width: 620px;
    height: 450px;
    /* transform: none !important; */
    /* position: absolute !important; */
  }
  @include mq(md) {
    width: 820px;
    height: 500px;
  }

  @include mq(lg) {
    width: 950px;
    height: 550px;
  }

  position: fixed;
  @include dark-shadow;
  line-height: 40px;
  z-index: 1042;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* transform: translateY(20%); */
  margin: auto;
  background-color: rgba(255, 255, 255, 1);
  font-size: 1.9rem;
  font-weight: 600;
  overflow: hidden;
  /* transition: all 0.5s ease; */
}

.model-diff {
  margin-top: 5px;
  color: rgba(0, 64, 128, 0.4);
}
.user-diff {
  position: absolute;
  left: 0;
  right: 0;
  top: 72%;
  margin: 0 auto;
  color: rgba(0, 64, 128, 0.4);
}

.close-modal {
  z-index: 220;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 1.5s ease;
}

h1 {
  font-weight: 700;
  font-size: 2.1rem;
  margin: 5px 0;
  padding-bottom: 10px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    width: 500px;
    height: 3px;
    background-color: #f88;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.window-inner {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 25px;
  line-height: 2.2rem;
  display: flex;
  flex-direction: column;

  div {
    &:hover {
      background-color: #fafafa;
      .window-left {
        border-right: 1px solid $main-color;
      }
    }
    display: flex;
    flex-direction: row;
    .window-left {
      box-sizing: border-box;
      transition: all 0.3s ease;
      flex-basis: 150px;
      min-width: 150px;
      width: 150px !important;
      font-size: 0.9rem;
      margin: 15px 0;
      @include flex-centerer-column;
      border-right: 1px solid #ddd;

      @include mq(sm) {
        font-size: 0.9rem;
      }
      @include mq(md) {
        font-size: 0.95rem;
      }

      @include mq(lg) {
        font-size: 1rem;
      }

      .ss-control {
        padding-top: 6px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        img {
          margin: 0 5px;
          width: 15px;
          height: 15px;
        }
        .turtle {
          width: 18px;
          height: 18px;
        }
      }

      img {
        cursor: pointer;
        width: 30px;
        height: 30px;
      }
    }
    .window-right {
      position: relative;
      flex: 1;
      box-sizing: border-box;
      font-size: 1.1rem;
      line-height: 1.3rem;
      padding: 10px 20px;
      text-align: center;

      @include mq(sm) {
        font-size: 1.1rem;
        line-height: 1.3rem;
      }
      @include mq(md) {
        font-size: 1.5rem;
        line-height: 2rem;
      }

      @include mq(lg) {
        font-size: 1.8rem;
      }

      @include flex-centerer-column;
      .state-indicator {
        position: absolute;
        bottom: 30px;
        right: 20px;
        /* @include centerer; */
        z-index: 0;
        @include flex-centerer-column;
        .spinner {
          transform: scale(1.8);
        }
        .text {
          font-size: 0.8rem;
          position: absolute;
          width: 100px;
          text-align: center;
          @include flex-centerer-row;
          top: 30px;
          z-index: 500;
        }
        .listening {
          color: $main-color;
        }
        .waiting {
          color: #ccc;
        }
      }

      .model-pron {
        margin-right: 0.5rem;
        letter-spacing: -1.1px;
        &:last-child {
          margin: 0;
        }
      }

      .speech-text {
        display: inline-block;
        position: relative;
        letter-spacing: -1px;
        vertical-align: middle;
        text-align: center;

        img {
          cursor: pointer;
          width: 30px;
          height: 30px;
          margin-left: 8px;
          /* position: absolute;
          right: -43px;
          top: 0;
          bottom: 0;
          margin: auto 0; */
        }
      }
    }
  }

  &:hover {
    .window-left {
      /* flex: 1; 
      
      */
    }
  }
}

.user {
  position: absolute;
  color: #555;
}
.interim {
  user-select: none;
  color: #ddd;
  filter: blur(2px);
  /* &:after {
    position: absolute;
    top: -1px;
    right: -40px;
    content: "...";
  } */
}

.problem-section-header {
  display: inline-block;
  margin: 36px 0 12px 0;
  top: 450px;
  /* margin-top: 36px; */
  /* margin-bottom: 6px; */
  padding: 12px 24px;
  font-size: 1rem;
  /* border-bottom-right-radius: 4px; */
  background-color: #999;
  color: white;
  z-index: 201;
}

// animations

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.window-fade-enter-active,
.window-fade-leave-active {
  transition: all 0.4s ease;
}
.window-fade-enter,
.window-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.window-slide-fade-enter-active,
.window-slide-fade-leave-active {
  transition: all 0.25s ease;
}

.window-slide-fade-enter {
  opacity: 0;
  transform: translateX(200px);
}

.window-slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-200px);
}

// model play
// play icon

.fade-enter-active {
  transition: all 0.3s ease;
}

.fade-enter {
  opacity: 0;
}

.slide-container {
  width: 50%;
  position: relative;
  .slider {
    width: 100%;
    cursor: pointer;
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: $main-color; /* Green background */
      cursor: pointer;
    }
  }
  /* Mouse-over effects */
  .slider:hover {
  }
}

.slider {
  -webkit-appearance: none;
  appearance: none;
  height: 3px;
  background: rgba(0, 0, 0, 0.15);
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    height: 100%;
    background-color: #f88;
    z-index: 1000;
  }
}

.phoneme {
  cursor: pointer;
  &:hover {
    transform: translateY(-2px);
  }
}

.workbook-type-container {
  font-weight: bold;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0 auto;
  font-size: 0.8rem;

  @include mq(sm) {
    font-size: 0.8rem;
  }
  @include mq(md) {
    font-size: 1rem;
  }
}

.active {
  background-color: #555 !important;
  color: white !important;
}

.workbook-type {
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 12px;
  border-right: 1px solid #ddd;
  .text {
    vertical-align: middle;
  }

  &:last-child {
    border: none;
  }
  .progress {
  }
  &:hover {
    background-color: #fafafa;
  }
}

.workbook-type-inner {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.right-control {
  display: inline-block;
  div {
    display: inline-block;
  }
}
.mirror-switch {
  border-radius: 0px 3px 0 0;
  z-index: 206;
}

.score {
  display: block;
}

.hide {
  opacity: 0;
}
.show {
  opacity: 1;
}

.gauge {
  transition: all 0.3s ease;
}

.header {
  display: inline-block;
  width: 100%;
  margin: 30px 0 0 30px;
  h2 {
    margin: 10px 0;
    font-size: 2rem;
  }
  .header-description {
    display: block;
    margin-bottom: 15px;
    font-size: 1.1rem;
    font-weight: bold;
  }
  img,
  .text {
    vertical-align: middle;
    display: inline-block;
  }

  img {
    width: 40px;
    margin-right: 10px;
  }
}

.status-bar {
  z-index: 1042;
  position: fixed;
  width: 400px;
  height: 70px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  font-size: 1rem;
  font-weight: bold;
}
.header {
  display: inline-block;
  width: 100%;
  margin: 30px 0 0 30px;
  h2 {
    margin: 10px 0;
    font-size: 1.8rem;
  }
  .header-description {
    display: block;
    margin-bottom: 15px;
    font-size: 0.9rem;
    font-weight: bold;
  }
  img,
  .text {
    vertical-align: middle;
    display: inline-block;
  }

  img {
    width: 40px;
    margin-right: 10px;
  }
}

table {
  overflow: hidden;
  margin: 0 30px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  width: 95%;
  border-radius: 5px;
  border-collapse: collapse;
  border-spacing: 0;
  td {
    text-align: center;
  }
  tr {
    height: 35px;
    min-width: 100%;
    &:first-child {
      height: 40px;
      border-bottom: 1px solid #eee;
    }
    &:last-child {
      height: 40px;
    }
  }
  .toggle {
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      background-color: #fafafa;
    }
  }
}

.playable {
  span {
    padding: 2px 10px;
  }
  /* transition: transform 0.25s ease; */
  &:hover {
    span {
      cursor: pointer;

      color: #fff;
      transform: scale(1.1);
      background-color: #f88;
      padding: 2px 10px;
      border-radius: 20px;
    }
  }
}

.ct-label {
  font-size: 1rem;
}
</style>


